/*
 * Copyright (C) 2021 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {WebseiteValidatorDirective} from '../shared/validators/webseite-validator.directive';
import {AddSozialdienstComponent} from './add-sozialdienst/add-sozialdienst.component';
import {EditSozialdienstComponent} from './edit-sozialdienst/edit-sozialdienst.component';
import {ListSozialdienstComponent} from './list-sozialdienst/list-sozialdienst.component';
import {SozialdienstRoutingModule} from './sozialdienst-routing/sozialdienst-routing.module';
import {UnterstuetzungdienstPermissionService} from '../authorisation/permissions/unterstuetzungdienst/Unterstuetzungdienst.permission.service';

@NgModule({
    declarations: [
        ListSozialdienstComponent,
        AddSozialdienstComponent,
        EditSozialdienstComponent
    ],
    imports: [
        SharedModule,
        SozialdienstRoutingModule,
        WebseiteValidatorDirective
    ],
    providers: [UnterstuetzungdienstPermissionService]
})
export class SozialdienstModule {}
